import { render, staticRenderFns } from "./qLanguageBox.vue?vue&type=template&id=dea00316&"
import script from "./qLanguageBox.vue?vue&type=script&lang=ts&"
export * from "./qLanguageBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports